import type { FaireThemeEntity } from "../../entity_types/theme";

export const holistic_apothecary_and_mineral_support: FaireThemeEntity = {
  token: "holistic-apothecary-and-mineral-support",
  type: "theme",
  name: "Holistic Apothecary & Mineral Support",
  description: "Expand your wellness selection with high-quality mineral supplements and health trackers to complement your current lineup of essential oils and salves.",
  teaser: "This theme fits Elsie Rose LLC because they already have a strong track record of ordering natural health products like healing balves, lymphatic lotions, and oral vitamins.",
  detail: "The additional_context payload shows specific recent searches for 'iodine', 'hain salt', 'transparent labs', and 'wellness tracker', indicating a move toward targeted nutritional support.",
  bgColor: "#FFD4D4",
  tileBgColor: "#3b6b3b",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_p33yxznuea",
    "p_7b9az77bav",
    "p_vqxnxmr8ng",
    "p_9k5ki1r4bw",
    "p_m8fgq7zw9f",
    "p_g54r83hxhc",
    "p_qpkswg7puc",
    "p_uqfqhegcar",
    "p_dyapjkvcv5",
    "p_9c467kaqyh",
    "p_ng8hns65vx",
    "p_dnxmt2u436",
    "p_mkcrfemyyn",
    "p_qgsjkj6h5e",
    "p_2fu34s8v70",
    "p_hq4thqn2wz",
    "p_3t74zhvp4m",
    "p_pc7994rd69",
    "p_958mj3kbr6",
    "p_36rpf4umnf",
    "p_tch3xnthsx",
    "p_p972zhtbcc",
    "p_uchkmjb828",
    "p_v4y8zvjhgv",
    "p_6bqyrkmnpc",
    "p_pgm62pczym",
    "p_g3t9xbnkuz",
    "p_cubazjx2hs",
    "p_mrmzv8ccb9",
    "p_1oldmyfr1b",
    "p_wyaxz37cx3",
    "p_df9jt0hwsn",
    "p_he4mng6tuj",
    "p_y8gh23k9bg",
    "p_4rqpzuym3v",
    "p_45kc8skjds",
    "p_jdjus8jffe",
    "p_pvqudgu73r",
    "p_tcavw9bfb4",
    "p_333uhua675",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
